module.exports = __webpack_public_path__ + "static/media/Profact_User_Walkthrough.36f2952d.8e72ccd1.pdf";